const font = require("./font");

const style = {
  backgroundColor: "#eeeeee",
  color: "#292a2e",
  fontFamily: font.family("georgia"),
};

style.loader = `
  .lds-ellipsis {
    display: inline-block;
    position: relative;
    width: 60px;
    height: 23px;
    margin: auto;
  }

  .lds-ellipsis div {
    position: absolute;
    top: 8px;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    animation-timing-function: cubic-bezier(0, 1, 1, 0);
    background: ${style.color};
  }

  .lds-ellipsis.alt div {
    background: ${style.backgroundColor};
  }

  .lds-ellipsis div:nth-child(1) {
    left: 6px;
    animation: loader1 0.6s infinite;
  }

  .lds-ellipsis div:nth-child(2) {
    left: 6px;
    animation: loader2 0.6s infinite;
  }

  .lds-ellipsis div:nth-child(3) {
    left: 26px;
    animation: loader2 0.6s infinite;
  }

  .lds-ellipsis div:nth-child(4) {
    left: 45px;
    animation: loader3 0.6s infinite;
  }

  @keyframes loader1 {
    0% {
      transform: scale(0);
    }
    100% {
      transform: scale(1);
    }
  }

  @keyframes loader3 {
    0% {
      transform: scale(1);
    }
    100% {
      transform: scale(0);
    }
  }

  @keyframes loader2 {
    0% {
      transform: translate(0, 0);
    }
    100% {
      transform: translate(19px, 0);
    }
  }
`;

style.base = `
  * {
    box-sizing: border-box;
  }

  html {
    scroll-behavior: smooth;
  }

  html,
  body {
    padding: 0;
    margin: 0;
  }

  body {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    margin: auto;
    align-items: baseline;
    color: ${style.color};
    background-color: ${style.backgroundColor};
    font-family: ${style.fontFamily};
  }

  a {
    color: inherit;
  }

  ${style.loader}
`;

module.exports = style;
